import { render, staticRenderFns } from "./PropertyFacComponent.vue?vue&type=template&id=1dc97535"
import script from "./PropertyFacComponent.vue?vue&type=script&lang=js"
export * from "./PropertyFacComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports